import React from 'react';
const FileCheckSVG = ({ color = 'black', className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='19'
      viewBox='0 0 16 19'
      fill='none'
      className={className}
    >
      <path
        d='M9.75 15.7222L11.5 17.5L15 13.9444M8 1.5H3.8C2.81991 1.5 2.32986 1.5 1.95552 1.69377C1.62623 1.8642 1.35851 2.13617 1.19074 2.47068C1 2.85097 1 3.3488 1 4.34444V14.6556C1 15.6512 1 16.1491 1.19074 16.5293C1.35851 16.8638 1.62623 17.1358 1.95552 17.3062C2.32986 17.5 2.81991 17.5 3.8 17.5H6.6875M8 1.5L13.25 6.83333M8 1.5V5.41111C8 5.90893 8 6.15785 8.09538 6.34799C8.17929 6.51524 8.31307 6.65123 8.47775 6.73645C8.66491 6.83333 8.90991 6.83333 9.4 6.83333H13.25M13.25 6.83333V10.7444M4.5 13.9444H6.6875M4.5 10.3889H9.75M4.5 6.83333H5.375'
        stroke={color}
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FileCheckSVG;
